import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["layers", "backgroundLayer", "mapKey"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useEffect, useState, Children, cloneElement, createElement, useRef } from 'react';
import PropTypes from 'prop-types';
import { forEach as _forEach, isEmpty as _isEmpty, mapValues as _mapValues, pickBy as _pickBy } from 'lodash';
import { map as mapUtils } from '@gisatcz/ptr-utils';
import { mapConstants } from '@gisatcz/ptr-core';
import MapGrid from '../MapGrid';
import './style.scss';
import MapWrapper from '../MapWrapper';
import * as ReactIs from 'react-is';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Map = function Map() {
  return null;
};
var PresentationMap = function PresentationMap() {
  return null;
};
var MapSet = function MapSet(_ref) {
  var onLayerClick = _ref.onLayerClick,
    onViewChange = _ref.onViewChange,
    onZoomEnd = _ref.onZoomEnd,
    onPanEnd = _ref.onPanEnd,
    connectedMapComponent = _ref.connectedMapComponent,
    backgroundLayer = _ref.backgroundLayer,
    layers = _ref.layers,
    updateView = _ref.updateView,
    activeMapKey = _ref.activeMapKey,
    onMount = _ref.onMount,
    onUnMount = _ref.onUnMount,
    activeMapView = _ref.activeMapView,
    activeMapViewport = _ref.activeMapViewport,
    _ref$disableMapRemova = _ref.disableMapRemoval,
    disableMapRemoval = _ref$disableMapRemova === void 0 ? false : _ref$disableMapRemova,
    maps = _ref.maps,
    mapComponent = _ref.mapComponent,
    view = _ref.view,
    stateMapSetKey = _ref.stateMapSetKey,
    sync = _ref.sync,
    wrapper = _ref.wrapper,
    _ref$wrapperProps = _ref.wrapperProps,
    wrapperProps = _ref$wrapperProps === void 0 ? {} : _ref$wrapperProps,
    Tooltip = _ref.Tooltip,
    tooltipProps = _ref.tooltipProps,
    children = _ref.children,
    onMapRemove = _ref.onMapRemove,
    resetHeading = _ref.resetHeading,
    onClick = _ref.onClick;
  var mapsDimensionsRef = useRef({});
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    mapsDimensions = _useState2[0],
    setMapsDimensions = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    mapViews = _useState4[0],
    setMapViews = _useState4[1];
  var _useState5 = useState(activeMapKey),
    _useState6 = _slicedToArray(_useState5, 2),
    stateActiveMapKey = _useState6[0],
    setStateActiveMapKey = _useState6[1];
  var _useState7 = useState(mapUtils.view.mergeViews(mapConstants.defaultMapView, view)),
    _useState8 = _slicedToArray(_useState7, 2),
    stateView = _useState8[0],
    setStateView = _useState8[1];
  useEffect(function () {
    var updateMapViews = _mapValues(mapViews, function (v) {
      return _objectSpread(_objectSpread({}, v), view);
    });
    setMapViews(updateMapViews);
    // TODO sync props to view only?
  }, [view]);
  useEffect(function () {
    if (!stateMapSetKey) {
      var updateMapViews = {};
      _forEach(children, function (child) {
        if (child && _typeof(child) === 'object' && (child.type === Map || child.type === connectedMapComponent || child.type === PresentationMap)) {
          updateMapViews[child.props.mapKey] = mapUtils.view.mergeViews(mapConstants.defaultMapView, view, child.props.view);
        }
      });
      if (!_isEmpty(updateMapViews)) {
        setMapViews(updateMapViews);
      }
      if (typeof onMount === 'function') {
        onMount();
      }
      if (typeof onUnMount === 'function') {
        return onUnMount;
      }
    }
  }, []);
  var onViewChangeLocal = function onViewChangeLocal(mapKey, update) {
    var syncUpdate;
    update = mapUtils.view.ensureViewIntegrity(update);
    mapKey = mapKey || stateActiveMapKey;
    if (sync) {
      syncUpdate = _pickBy(update, function (updateVal, updateKey) {
        return sync[updateKey];
      });
      syncUpdate = mapUtils.view.ensureViewIntegrity(syncUpdate);
    }
    // merge views of all maps
    var updateMapViews = _mapValues(mapViews, function (v) {
      return mapUtils.view.mergeViews(v, syncUpdate);
    });

    // merge views of given map
    updateMapViews[mapKey] = mapUtils.view.mergeViews(mapViews[mapKey], update);
    setMapViews(updateMapViews);
    if (syncUpdate && !_isEmpty(syncUpdate)) {
      var mergedView = mapUtils.view.mergeViews(stateView, syncUpdate);
      setStateView(mergedView);
      if (onViewChange) {
        onViewChange(mergedView);
      }
    }
  };
  var onResetHeading = function onResetHeading() {
    mapUtils.resetHeading(mapViews[stateActiveMapKey].heading, function (heading) {
      return onViewChangeLocal(stateActiveMapKey, {
        heading: heading
      });
    });
  };

  /**
   * Called in uncontrolled map set
   * @param key
   * @param view
   */
  var onMapClick = function onMapClick(key, view) {
    if (!mapViews[key]) {
      var updateMapViews = _objectSpread({}, mapViews);
      updateMapViews[key] = view;
      setMapViews(updateMapViews);
    }
    setStateActiveMapKey(key);
  };
  var onMapResize = function onMapResize(width, height, mapKey) {
    var updatedMapsDimensions = _objectSpread(_objectSpread({}, mapsDimensionsRef.current), {}, _defineProperty({}, mapKey, {
      width: width,
      height: height
    }));
    mapsDimensionsRef.current = updatedMapsDimensions;
    setMapsDimensions(updatedMapsDimensions);
  };
  var renderControls = function renderControls() {
    var customUpdateView, customResetHeading, mergedView, mapKey, activeMapDimensions;
    if (stateMapSetKey) {
      mergedView = activeMapView || view;
      mapKey = activeMapKey;
      activeMapDimensions = activeMapViewport;
    } else {
      customUpdateView = function customUpdateView(update, mkey) {
        return onViewChangeLocal(mkey, update);
      };
      customResetHeading = onResetHeading;
      mergedView = mapUtils.view.mergeViews(stateView, mapViews[stateActiveMapKey]);
      mapKey = stateActiveMapKey;
      activeMapDimensions = mapsDimensions && mapsDimensions[stateActiveMapKey];
    }
    var newChildren = [];
    Children.forEach(children, function (child) {
      if (!(_typeof(child) === 'object' && (child.type === Map || child.type === connectedMapComponent || child.type === PresentationMap))) {
        newChildren.push( /*#__PURE__*/cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
          view: mergedView,
          updateView: stateMapSetKey ? updateView : customUpdateView,
          resetHeading: customResetHeading || resetHeading,
          mapKey: mapKey,
          mapWidth: activeMapDimensions && activeMapDimensions.width,
          mapHeight: activeMapDimensions && activeMapDimensions.height
        })));
      }
    });
    return newChildren;
  };
  var renderMap = function renderMap(mapComponent, props, children, active, renderWrapper) {
    // TODO custom wrapper component
    if (wrapper) {
      var mergedWrapperProps = _objectSpread({}, wrapperProps);
      if (onMapRemove && !disableMapRemoval) {
        mergedWrapperProps['onMapRemove'] = onMapRemove;
      }
      var allProps = _objectSpread(_objectSpread(_objectSpread({}, props), mergedWrapperProps), {}, {
        wrapper: wrapper,
        active: active
      });
      // Render wrapper here, if mapComponent is final (framework-specific) map component
      if (renderWrapper) {
        var wrapperComponent = ReactIs.isValidElementType(wrapper) ? wrapper : MapWrapper;
        return /*#__PURE__*/createElement(wrapperComponent, allProps, /*#__PURE__*/createElement(mapComponent, props, children));
      } else {
        return /*#__PURE__*/createElement(mapComponent, allProps, children);
      }
    } else {
      return /*#__PURE__*/createElement(mapComponent, props, children);
    }
  };
  var renderMaps = function renderMaps() {
    var mapsToRender = [];

    // For now, render either maps from state, OR from children

    if (stateMapSetKey) {
      // all from state
      if (maps && maps.length) {
        maps.map(function (mapKey) {
          var props = {
            key: mapKey,
            stateMapKey: mapKey,
            onResize: function onResize(w, h) {
              return onMapResize(w, h, mapKey);
            },
            onViewChange: function onViewChange(update) {
              return onViewChangeLocal(mapKey, update);
            },
            onZoomEnd: onZoomEnd,
            onPanEnd: onPanEnd,
            // onClick: view => onMapClick(mapKey, view),
            onClick: onClick,
            onLayerClick: onLayerClick,
            wrapperProps: wrapperProps,
            onMapRemove: onMapRemove,
            Tooltip: Tooltip,
            tooltipProps: tooltipProps
          };
          mapsToRender.push(renderMap(connectedMapComponent, _objectSpread(_objectSpread({}, props), {}, {
            mapComponent: mapComponent
          }), null, mapKey === activeMapKey));
        });
      }
    } else {
      Children.map(children, function (child, index) {
        var _child$props = child.props,
          childLayers = _child$props.layers,
          childBackgroundLayer = _child$props.backgroundLayer,
          childMapKey = _child$props.mapKey,
          restProps = _objectWithoutProperties(_child$props, _excluded);
        var props = _objectSpread(_objectSpread({}, restProps), {}, {
          key: index,
          view: mapUtils.view.mergeViews(view, stateView, mapViews[childMapKey]),
          backgroundLayer: childBackgroundLayer || backgroundLayer,
          layers: mapUtils.mergeLayers(layers, childLayers),
          onViewChange: function onViewChange(update) {
            return onViewChangeLocal(childMapKey, update);
          },
          onZoomEnd: onZoomEnd,
          onPanEnd: onPanEnd,
          onLayerClick: onLayerClick,
          onClick: function onClick(view) {
            return onMapClick(childMapKey, view);
          },
          onResize: function onResize(w, h) {
            return onMapResize(w, h, childMapKey);
          },
          mapKey: childMapKey
        });
        if (_typeof(child) === 'object' && (child.type === Map || child.type === connectedMapComponent)) {
          // layers from state
          mapsToRender.push(renderMap(connectedMapComponent, _objectSpread(_objectSpread({}, props), {}, {
            mapComponent: mapComponent
          }), null, childMapKey === stateActiveMapKey));
        } else if (_typeof(child) === 'object' && child.type === PresentationMap) {
          // all presentational
          mapsToRender.push(renderMap(mapComponent || child.props.mapComponent, props, child.props.children, childMapKey === stateActiveMapKey, true));
        }
      });
    }
    return /*#__PURE__*/_jsx(MapGrid, {
      children: mapsToRender
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "ptr-map-set",
    children: [/*#__PURE__*/_jsx("div", {
      className: "ptr-map-set-maps",
      children: renderMaps()
    }), /*#__PURE__*/_jsx("div", {
      className: "ptr-map-set-controls",
      children: renderControls()
    })]
  });
};
MapSet.propTypes = {
  activeMapKey: PropTypes.string,
  activeMapView: PropTypes.object,
  activeMapViewport: PropTypes.object,
  backgroundLayer: PropTypes.object,
  children: PropTypes.node,
  connectedMapComponent: PropTypes.elementType,
  mapComponent: PropTypes.elementType,
  disableMapRemoval: PropTypes.bool,
  layers: PropTypes.array,
  mapSetKey: PropTypes.string,
  maps: PropTypes.array,
  onMapRemove: PropTypes.func,
  onMount: PropTypes.func,
  onUnMount: PropTypes.func,
  onViewChange: PropTypes.func,
  onZoomEnd: PropTypes.func,
  onPanEnd: PropTypes.func,
  onLayerClick: PropTypes.func,
  resetHeading: PropTypes.func,
  stateMapSetKey: PropTypes.string,
  sync: PropTypes.object,
  updateView: PropTypes.func,
  //don't sure with it. It should enought onViewChange?
  view: PropTypes.object,
  wrapper: PropTypes.oneOfType([PropTypes.elementType, PropTypes.bool]),
  wrapperProps: PropTypes.object,
  Tooltip: PropTypes.elementType,
  tooltipProps: PropTypes.object,
  onClick: PropTypes.func
};
export var MapSetMap = Map;
export var MapSetPresentationMap = PresentationMap;
export default MapSet;